import React, { useState } from 'react'
import { Field, ErrorMessage, getIn } from 'formik'
import ErrorPopUp from '../../Shared/ErrorPopUp'
import { AsyncCategorySelect } from '../../Shared/AsyncCategorySelect'
import AsyncBrandSelect from '../../Shared/AsyncBrandSelect'
import AsyncProductSelect from '../../Shared/AsyncProductSelect'
import MeasurementTypeDoubleBox from '../../Shared/MeasurementTypeDoubleBox'
import { MdClose } from 'react-icons/md'
import { GoPlus } from 'react-icons/go'
import Fab from '@material-ui/core/Fab'
import { productsService } from '../../../_services/products.service'
import QtyInput from '../../Shared/QtyInput'
import { AiOutlineLoading } from 'react-icons/ai'

import ReservedTaskModal from '../Reserve/ReservedTaskModal'

const item = {
  categoryId: '',
  brandId: '',
  itemId: '',
  unitProductQuantity: 0,
  taskOperationProductType: 0
}

const Step2 = ({
  touched,
  errors,
  setFieldValue,
  values,
  handleBlur,
  taskType,
  newReserve
}) => {
  const [reservedModalId, setReservedModalId] = useState(undefined)
  const getUnitProductQuantity = (productId, index) => {
    setFieldValue(`items[${index}][loading]`, true)
    setFieldValue(`items[${index}][productOrderableQuantity]`, undefined)
    setFieldValue(
      `items[${index}][productOrderableQuantityWithoutReserves]`,
      undefined
    )
    setFieldValue(`items[${index}][productQuantity]`, undefined)

    productsService
      .getProductQuantity(productId)
      .then(res => {
        console.log(res.data)
        setFieldValue(
          `items[${index}][productOrderableQuantity]`,
          res.data.orderableQuantity
        )
        setFieldValue(
          `items[${index}][productOrderableQuantityWithoutReserves]`,
          res.data.orderableQuantityWithoutReserves
        )
        setFieldValue(
          `items[${index}][reservedTaskCodes]`,
          res.data.reservedTaskCodes
        )
        setFieldValue(`items[${index}][productQuantity]`, res.data.quantity)
        setFieldValue(
          `items[${index}][orderableQuantity]`,
          res.data.orderableQuantity
        )
        setFieldValue(`items[${index}][loading]`, false)
      })
      .catch(error => {
        setFieldValue(`items[${index}][loading]`, false)
        console.log(error)
      })
  }

  const clearProduct = index => {
    setFieldValue(`items[${index}][productOrderableQuantity]`, undefined)
    setFieldValue(
      `items[${index}][productOrderableQuantityWithoutReserves]`,
      undefined
    )
    setFieldValue(`items[${index}][productQuantity]`, undefined)
    setFieldValue(`items[${index}][productId]`, '')
    setFieldValue(`items[${index}][product]`, '')
  }

  return (
    <div className="row display-flex">
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <fieldset className="fieldset">
          <legend>لیست مواد اولیه جهت تولید محصول</legend>

          <table className="table validator-table">
            <thead>
              <tr>
                <th className="text-center">ردیف</th>
                <th className="text-center">دسته بندی</th>
                <th className="text-center">برند</th>
                <th className="text-center">مواد اولیه</th>
                <th className="text-center">مقدار رزور</th>
                <th className="text-center">
                  موجودی قابل سفارش با احتساب رزرو شده
                </th>
                <th className="text-center">موجودی قابل سفارش</th>
                <th className="text-center">موجودی فعلی انبار</th>
                <th className="text-center">حذف</th>
              </tr>
            </thead>
            <tbody>
              {values.items &&
                values.items.map((item, index) => (
                  <tr key={'p-' + index}>
                    <td style={{ height: 125 }}>{index + 1}</td>
                    <td>
                      <AsyncCategorySelect
                        clearable
                        className="semantic-select-box"
                        categoryType={0}
                        defaultValue={values.items[index].categoryId}
                        onChange={val => {
                          setFieldValue(`items[${index}][categoryId]`, val)
                          clearProduct(index)
                          // setFieldValue(`items[${index}][productId]`, '')
                        }}
                      />
                      <ErrorMessage
                        component={ErrorPopUp}
                        name={`items[${index}].categoryId`}
                        type="select"
                      />
                    </td>
                    <td>
                      <AsyncBrandSelect
                        clearable
                        className="semantic-select-box"
                        brandType={0}
                        defaultValue={values.items[index].brandId}
                        onChange={val => {
                          setFieldValue(`items[${index}][brandId]`, val)
                          clearProduct(index)
                          // setFieldValue(`items[${index}][productId]`, '')
                        }}
                      />
                      <ErrorMessage
                        component={ErrorPopUp}
                        name={`items[${index}].brandId`}
                        type="select"
                      />
                    </td>
                    <td>
                      <AsyncProductSelect
                        clearable
                        className="semantic-select-box"
                        brandId={values.items[index].brandId}
                        categoryId={values.items[index].categoryId}
                        defaultValue={values.items[index].productId}
                        onChange={val => {
                          setFieldValue(
                            `items[${index}][productId]`,
                            val ? val.value : ''
                          )
                          setFieldValue(
                            `items[${index}][product]`,
                            val ? val : ''
                          )
                          if (val) {
                            getUnitProductQuantity(val.value, index)
                          } else {
                            setFieldValue(
                              `items[${index}][productOrderableQuantity]`,
                              undefined
                            )
                            setFieldValue(
                              `items[${index}][productOrderableQuantityWithoutReserves]`,
                              undefined
                            )
                            setFieldValue(
                              `items[${index}][productQuantity]`,
                              undefined
                            )
                            setFieldValue(
                              `items[${index}][reservedTaskCodes]`,
                              undefined
                            )
                          }
                          // setFieldValue(
                          //   `items[${index}][unitProductQuantity]`,
                          //   val ? val.quantity : ''
                          // )
                        }}
                      />

                      {values.items[index].reservedTaskCodes &&
                      values.items[index].reservedTaskCodes.length > 0 ? (
                        <React.Fragment>
                          <br />
                          <a
                            onClick={() =>
                              setReservedModalId(values.items[index].productId)
                            }>
                            <div className="notification">
                              این مواد اولیه برای سفارش های زیر رزرو شده است:{' '}
                              {values.items[index].reservedTaskCodes.toString()}
                            </div>
                          </a>
                        </React.Fragment>
                      ) : (
                        ''
                      )}
                      <ErrorMessage
                        component={ErrorPopUp}
                        name={`items[${index}].productId`}
                        type="select"
                      />
                    </td>

                    {/* <td>
                      {values.items[index].loading ? (
                        <AiOutlineLoading
                          className="mdi-spin-fast"
                          size="20px"
                          color="#8E2DE2"
                        />
                      ) : values.items[index].product ? (
                        values.items[index].productOrderableQuantity ? (
                          <MeasurementTypeDoubleBox
                            product={values.items[index].product}
                            value={values.items[index].productOrderableQuantity}
                            // onlySub={values.items[index].product.subMeasurementType !== undefined ? true : false}
                          />
                        ) : (
                          0
                        )
                      ) : (
                        '-'
                      )}
                    </td> */}
                    <td>
                      <div>
                        <QtyInput
                          disabled={
                            values.items[index].product
                              ? values.items[index].product.conversionUnit
                              : false
                          }
                          className="text-input"
                          measurementType={
                            values.items[index].product
                              ? values.items[index].product.measurementType
                              : undefined
                          }
                          subMeasurementType={
                            values.items[index].product
                              ? values.items[index].product.subMeasurementType
                              : undefined
                          }
                          conversionUnit={
                            values.items[index].product
                              ? values.items[index].product.conversionUnit
                              : undefined
                          }
                          onChange={(val, subVal) => {
                            console.log(val, subVal)
                            if (val <= values.items[index].productQuantity) {
                              console.log('here')
                              setFieldValue(
                                `items[${index}][subQuantity]`,
                                subVal
                              )
                              setFieldValue(`items[${index}][quantity]`, val)
                            } else {
                              setFieldValue(`items[${index}][subQuantity]`, 0)
                              setFieldValue(`items[${index}][quantity]`, 0)
                            }
                          }}
                          // max={values.items[index].quantity}
                          defualtValue={values.items[index].quantity}
                          defualtSubValue={values.items[index].subQuantity}
                        />
                        <ErrorMessage
                          component={ErrorPopUp}
                          name={`items[${index}].quantity`}
                          style={{ margin: '0 auto' }}
                        />
                      </div>
                      {/* {JSON.stringify(values.items[index])} */}
                    </td>
                    <td>
                      {values.items[index].loading ? (
                        <AiOutlineLoading
                          className="mdi-spin-fast"
                          size="20px"
                          color="#8E2DE2"
                        />
                      ) : values.items[index].product ? (
                        values.items[index]
                          .productOrderableQuantityWithoutReserves ? (
                          <MeasurementTypeDoubleBox
                            product={values.items[index].product}
                            value={
                              values.items[index]
                                .productOrderableQuantityWithoutReserves
                            }
                            // onlySub={values.items[index].product.subMeasurementType !== undefined ? true : false}
                          />
                        ) : (
                          0
                        )
                      ) : (
                        '-'
                      )}
                    </td>
                    <td>
                      {values.items[index].loading ? (
                        <AiOutlineLoading
                          className="mdi-spin-fast"
                          size="20px"
                          color="#8E2DE2"
                        />
                      ) : values.items[index].product ? (
                        values.items[index].orderableQuantity ? (
                          <MeasurementTypeDoubleBox
                            product={values.items[index].product}
                            value={values.items[index].orderableQuantity}
                            // onlySub={values.items[index].product.subMeasurementType !== undefined ? true : false}
                          />
                        ) : (
                          0
                        )
                      ) : (
                        '-'
                      )}

                      {/* <div className="flex-col flex-center">
                    <span style={{ marginBottom: 10 }}>
                      {values.items[index].unitProductQuantity} {values.items[index].product ? '(' + measurementTypes.filter(el => el.value === values.items[index].product.measurementType)[0].label + ')' : ''}
                    </span>
                    {values.items[index].product && values.items[index].product.conversionUnit ?
                      <span>
                        {(Number((values.items[index].unitProductQuantity / values.items[index].product.conversionUnit).toFixed(3)) + (values.items[index].product.subMeasurementType !== undefined
                          ? ' (' + measurementTypes.filter(el => el.value === values.items[index].product.subMeasurementType)[0].label + ')'
                          : ''))}
                      </span>
                      : ''}
                  </div> */}
                    </td>
                    <td>
                      {values.items[index].loading ? (
                        <AiOutlineLoading
                          className="mdi-spin-fast"
                          size="20px"
                          color="#8E2DE2"
                        />
                      ) : values.items[index].product ? (
                        values.items[index].productQuantity ? (
                          <MeasurementTypeDoubleBox
                            product={values.items[index].product}
                            value={values.items[index].productQuantity}
                            // onlySub={values.items[index].product.subMeasurementType !== undefined ? true : false}
                          />
                        ) : (
                          0
                        )
                      ) : (
                        '-'
                      )}
                    </td>
                    <td>
                      <a
                        onClick={e => {
                          e.preventDefault()
                          let items = values.items
                          if (items && items.length > 1) {
                            items.splice(index, 1)
                            setFieldValue('items', items)
                          }
                        }}>
                        <MdClose size="24px" color="#F34255" />
                      </a>
                    </td>
                  </tr>
                ))}
              <tr>
                <td>
                  <Fab
                    color="secondary"
                    aria-label="refresh"
                    size="small"
                    onClick={() => {
                      let items = values.items
                      items.push(item)
                      setFieldValue('items', items)
                    }}
                    className="modal-close-btn">
                    <GoPlus size="20px" />
                  </Fab>
                </td>
                <td colSpan="6" />
              </tr>
            </tbody>
          </table>
          {errors.items ? (
            <ErrorPopUp
              error={
                newReserve == true
                  ? 'حداقل 1 نوع مواد اولیه'
                  : taskType == 1
                  ? 'حداقل 3 نوع مواد اولیه'
                  : 'حداقل 1 نوع مواد اولیه'
              }
              type="select"
              touched
            />
          ) : (
            ''
          )}
        </fieldset>
      </div>
      <ReservedTaskModal
        taskCode={reservedModalId}
        onClose={() => setReservedModalId(undefined)}
      />
    </div>
  )
}

export default Step2
